import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CreateNewExceptionState } from '../../actions/types/exceptions/CreateNewExceptionTypes';

/**
 * Initial Dashboard state in store
 */
export const initialState: CreateNewExceptionState = {
  isLoading: false,
  success: false,
  errorMessage: '',
  CreateNewExceptions: [],
};

/**
 * get metric summary Slice to get metric
 */
export const getCreateNewExceptionSlice = createSlice({
  name: 'getMetricsSummary',
  initialState,
  reducers: {
    getCreateNewExceptionStarted: (state) => {
      state.isLoading = true;
    },
    getCreateNewExceptionSuccess: (state, action: PayloadAction<any>) => {
      state.isLoading = false;
      state.success = true;
      state.errorMessage = '';
      state.CreateNewExceptions = action.payload;
    },

    getCreateNewExceptionFail: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.success = false;
      state.errorMessage = action.payload;
      state.CreateNewExceptions = initialState.CreateNewExceptions;
    },

    clearCreateNewException: (state) => {
      state.isLoading = false;
      state.success = false;
      state.errorMessage = '';
      state.CreateNewExceptions = initialState.CreateNewExceptions;
    },
  },
});

export const {
  getCreateNewExceptionStarted,
  getCreateNewExceptionSuccess,
  getCreateNewExceptionFail,
  clearCreateNewException,
} = getCreateNewExceptionSlice.actions;
export default getCreateNewExceptionSlice.reducer;
